import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Icon,
} from 'semantic-ui-react';


export default class ContentPlaceholder extends Component {
  static propTypes = {
    header: PropTypes.bool,
    subheader: PropTypes.bool,
    paragraphs: PropTypes.oneOfType([
      PropTypes.bool,
      PropTypes.number,
    ]),
    loading: PropTypes.bool,
    content: PropTypes.node,
    children: PropTypes.node,
    direction: PropTypes.string,
    expandable: PropTypes.bool,
    onMore: PropTypes.func,
    isExpanded: PropTypes.bool,
  }
  constructor(props) {
    super(props);
    this.state = {
      isExpanded: false,
      needExpand: false,
    };
    this.content = null;
  }
  componentDidMount() {
    if (this.props.expandable) {
      document.addEventListener('DOMContentLoaded', this.handleCheckExpand, false);
      window.addEventListener('scroll', this.handleCheckExpand, false);
      window.addEventListener('resize', this.handleCheckExpand, false);
    }
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.expandable) {
      const isExpanded = nextProps.isExpanded;
      if (isExpanded !== undefined) {
        this.setState({ isExpanded });
      }
    }
  }
  componentWillUnmount() {
    document.removeEventListener('DOMContentLoaded', this.handleCheckExpand, false);
    window.removeEventListener('scroll', this.handleCheckExpand, false);
    window.removeEventListener('resize', this.handleCheckExpand, false);
  }
  handleCheckExpand = () => {
    const needExpand = this.checkExpand();
    if (needExpand !== this.state.needExpand) {
      this.setState({ needExpand });
    }
  }
  documentHeight = () => Math.max(
    document.documentElement.clientHeight,
    document.body.offsetHeight,
    document.documentElement.offsetHeight,
  );
  checkExpand = () => {
    if (this.content) {
      const minHeight = this.documentHeight() / 3;
      return this.content.clientHeight > minHeight;
    }
    return this.state.isExpanded;
  }
  handleOnMore = (e) => {
    if (this.props.expandable) {
      let isExpanded = !this.state.isExpanded;
      if (this.props.isExpanded !== undefined) {
        isExpanded = this.props.isExpanded;
      }
      this.setState({ isExpanded }, () => {
        if (this.props.onMore) {
          this.props.onMore(e, isExpanded);
        }
      });
    }
  }
  checkLoading = () => this.props.loading &&
    (this.props.header || this.props.subheader || this.props.paragraphs);
  renderRows = () => {
    let total = 4;
    if (this.props.paragraphs && typeof this.props.paragraphs === 'number') {
      total = this.props.paragraphs;
    }
    const rows = new Array(total);
    rows.fill('paragraph', 0, total);
    return rows.map((r, idx) => (
      <div key={idx} className={r} />
    ));
  };
  render() {
    const classNames = [];
    if (this.checkLoading()) {
      classNames.push('content-placeholder');
      if (this.props.direction) {
        classNames.push(this.props.direction);
      }
    } else if (this.props.expandable) {
      if (this.state.needExpand && !this.state.isExpanded) {
        classNames.push('expandable');
      }
    }
    return (
      <div
        ref={(ref) => { this.content = ref; }}
        className={classNames.join(' ')}
      >
        {
          this.checkLoading() && this.props.header ?
            <div className="header" /> : null
        }
        {
          this.checkLoading() && this.props.subheader ?
            <div className="header sub" /> : null
        }
        {
          this.checkLoading() && this.props.paragraphs ?
            this.renderRows() : null
        }
        {
          !this.checkLoading() ?
          (this.props.children || this.props.content) : null
        }
        {
          !this.checkLoading() && this.props.expandable && this.state.needExpand &&
          <div className="show-more">
            <a onClick={this.handleOnMore}>
              <Icon
                name={this.state.isExpanded ? 'chevron up' : 'chevron down'}
              />
              {this.state.isExpanded ? 'Collapse' : 'Show more'}
            </a>
          </div>
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ContentPlaceholder.jsx